export const translations = {
  en: {
    nav: { services: "Services", about: "Approach", testimonials: "Voices", quote: "Get a quote", book: "Book now" },
    hero: {
      eyebrow: "Cleaning company — Utrecht, NL",
      line1: "Immaculate",
      line2: "spaces,",
      line3: "cozy living.",
      sub: "Cozy Home is a Utrecht-based cleaning company for post-renovation sites, restaurants, hospitality, offices and private homes — where precision meets warmth.",
      cta: "Request a quote",
      scroll: "Scroll to explore",
    },
    marquee: ["Premium Cleaning", "Utrecht", "Post-Renovation", "Hospitality", "Private Homes", "Restaurants & Bars", "Offices"],
    banner: {
      badge: "Weekly plan",
      title: "Book weekly cleaning,",
      titleEm: "save 10%.",
      sub: "Set up a recurring weekly clean for your home or business and enjoy 10% off every single visit.",
      cta: "Claim 10% off",
    },
    manifesto: {
      title: "Care, in every corner.",
      items: [
        { n: "01", h: "We treat rooms like homes", p: "Every space we touch is left calm, bright and breathable. We don't just clean surfaces — we restore the feeling of a place." },
        { n: "02", h: "Trained, discreet, reliable", p: "A vetted Utrecht team with the right products for every material. Insured, punctual and quietly thorough from the first visit." },
        { n: "03", h: "Detail is the difference", p: "Skirting boards, grout lines, glass edges. The parts nobody notices until they shine — that's exactly where our attention goes." },
      ],
    },
    services: {
      title: "What we clean",
      sub: "Four specialisms, one standard.",
      list: [
        { t: "Post-renovation", d: "Dust removal, residue, paint splatter and deep detailing to make a fresh build move-in ready." },
        { t: "Restaurants, bars & offices", d: "Reliable recurring cleaning for high-traffic commercial spaces, on your schedule." },
        { t: "Hospitality & accommodation", d: "Turnover cleaning for hotels, B&Bs and short-stays with hotel-grade consistency." },
        { t: "Private homes", d: "Regular or one-off home cleaning with a warm, trustworthy and detail-driven touch." },
      ],
    },
    testimonials: {
      title: "Voices",
      list: [
        { q: "After our renovation, Cozy Home turned a dusty site into a home in a single day. Flawless.", a: "Marieke V., Utrecht" },
        { q: "Our restaurant has never looked this sharp. Punctual, discreet and genuinely thorough.", a: "Lorenzo B., Restaurant owner" },
        { q: "The most reliable cleaning team we've worked with across our guest houses.", a: "Sanne D., Hospitality manager" },
      ],
    },
    form: {
      title: "Get a quote",
      sub: "Tell us about your space. We reply within one business day.",
      name: "Full name",
      email: "Email",
      phone: "Phone (optional)",
      service: "Service needed",
      serviceOptions: ["Post-renovation", "Restaurants, bars & offices", "Hospitality & accommodation", "Private homes"],
      frequency: "Cleaning frequency",
      frequencyOptions: [
        { value: "Weekly (10% off)", label: "Weekly — save 10%", discount: true },
        { value: "Bi-weekly", label: "Bi-weekly" },
        { value: "Monthly", label: "Monthly" },
        { value: "One-time", label: "One-time" },
      ],
      discountNote: "Nice choice — a 10% weekly discount will be applied to your quote.",
      message: "Tell us about your space",
      submit: "Send request",
      sending: "Sending…",
      success: "Thank you — we'll be in touch within one business day.",
      error: "Something went wrong. Please try again.",
    },
    booking: {
      title: "Book now",
      sub: "Pick your preferred date and time. We'll confirm within one business day.",
      name: "Full name",
      email: "Email",
      phone: "Phone (optional)",
      service: "Service needed",
      date: "Preferred date",
      time: "Preferred time",
      message: "Anything we should know? (optional)",
      submit: "Request booking",
      sending: "Sending…",
      success: "Thank you — we'll confirm your booking within one business day.",
      error: "Something went wrong. Please try again.",
      back: "Back to site",
    },
    footer: { tagline: "Cleaning studio", address: "Utrecht, Netherlands", rights: "All rights reserved.", contact: "Contact" },
  },
  nl: {
    nav: { services: "Diensten", about: "Aanpak", testimonials: "Stemmen", quote: "Offerte aanvragen", book: "Boek nu" },
    hero: {
      eyebrow: "Schoonmaakbedrijf — Utrecht, NL",
      line1: "Smetteloze",
      line2: "ruimtes,",
      line3: "warm wonen.",
      sub: "Cozy Home is een schoonmaakbedrijf uit Utrecht voor oplevering na renovatie, restaurants, horeca, kantoren en particuliere woningen — waar precisie en warmte samenkomen.",
      cta: "Offerte aanvragen",
      scroll: "Scroll om te ontdekken",
    },
    marquee: ["Premium Schoonmaak", "Utrecht", "Na Renovatie", "Horeca", "Particuliere Woningen", "Restaurants & Bars", "Kantoren"],
    banner: {
      badge: "Wekelijks plan",
      title: "Boek wekelijkse schoonmaak,",
      titleEm: "bespaar 10%.",
      sub: "Stel een terugkerende wekelijkse schoonmaak in voor je woning of bedrijf en profiteer van 10% korting op elk bezoek.",
      cta: "Claim 10% korting",
    },
    manifesto: {
      title: "Zorg, in elke hoek.",
      items: [
        { n: "01", h: "We behandelen ruimtes als thuis", p: "Elke ruimte laten we rustig, licht en fris achter. We reinigen niet alleen oppervlakken — we herstellen het gevoel van een plek." },
        { n: "02", h: "Getraind, discreet, betrouwbaar", p: "Een gescreend Utrechts team met de juiste producten voor elk materiaal. Verzekerd, punctueel en grondig vanaf het eerste bezoek." },
        { n: "03", h: "Detail maakt het verschil", p: "Plinten, voegen, glasranden. De delen die niemand opmerkt tot ze glanzen — daar gaat onze aandacht naartoe." },
      ],
    },
    services: {
      title: "Wat we schoonmaken",
      sub: "Vier specialismen, één standaard.",
      list: [
        { t: "Na renovatie", d: "Stofverwijdering, resten, verfspatten en dieptereiniging om een nieuwbouw instapklaar te maken." },
        { t: "Restaurants, bars & kantoren", d: "Betrouwbare terugkerende schoonmaak voor drukke commerciële ruimtes, op jouw schema." },
        { t: "Horeca & accommodatie", d: "Wisselschoonmaak voor hotels, B&B's en verblijven met hotelwaardige consistentie." },
        { t: "Particuliere woningen", d: "Regelmatige of eenmalige woningschoonmaak met een warme, betrouwbare en detailgerichte touch." },
      ],
    },
    testimonials: {
      title: "Stemmen",
      list: [
        { q: "Na onze renovatie maakte Cozy Home van een stoffige plek in één dag een thuis. Onberispelijk.", a: "Marieke V., Utrecht" },
        { q: "Ons restaurant heeft er nog nooit zo strak uitgezien. Punctueel, discreet en echt grondig.", a: "Lorenzo B., Restauranthouder" },
        { q: "Het meest betrouwbare schoonmaakteam waarmee we in onze gastenverblijven hebben gewerkt.", a: "Sanne D., Horecamanager" },
      ],
    },
    form: {
      title: "Offerte aanvragen",
      sub: "Vertel ons over je ruimte. We reageren binnen één werkdag.",
      name: "Volledige naam",
      email: "E-mail",
      phone: "Telefoon (optioneel)",
      service: "Gewenste dienst",
      serviceOptions: ["Na renovatie", "Restaurants, bars & kantoren", "Horeca & accommodatie", "Particuliere woningen"],
      frequency: "Schoonmaakfrequentie",
      frequencyOptions: [
        { value: "Wekelijks (10% korting)", label: "Wekelijks — 10% korting", discount: true },
        { value: "Tweewekelijks", label: "Tweewekelijks" },
        { value: "Maandelijks", label: "Maandelijks" },
        { value: "Eenmalig", label: "Eenmalig" },
      ],
      discountNote: "Goede keuze — er wordt 10% wekelijkse korting op je offerte toegepast.",
      message: "Vertel ons over je ruimte",
      submit: "Aanvraag versturen",
      sending: "Versturen…",
      success: "Bedankt — we nemen binnen één werkdag contact op.",
      error: "Er ging iets mis. Probeer het opnieuw.",
    },
    booking: {
      title: "Boek nu",
      sub: "Kies je gewenste datum en tijd. We bevestigen binnen één werkdag.",
      name: "Volledige naam",
      email: "E-mail",
      phone: "Telefoon (optioneel)",
      service: "Gewenste dienst",
      date: "Gewenste datum",
      time: "Gewenste tijd",
      message: "Iets dat we moeten weten? (optioneel)",
      submit: "Boeking aanvragen",
      sending: "Versturen…",
      success: "Bedankt — we bevestigen je boeking binnen één werkdag.",
      error: "Er ging iets mis. Probeer het opnieuw.",
      back: "Terug naar site",
    },
    footer: { tagline: "Schoonmaakstudio", address: "Utrecht, Nederland", rights: "Alle rechten voorbehouden.", contact: "Contact" },
  },
  it: {
    nav: { services: "Servizi", about: "Metodo", testimonials: "Recensioni", quote: "Richiedi preventivo", book: "Prenota ora" },
    hero: {
      eyebrow: "Impresa di pulizie — Utrecht, NL",
      line1: "Spazi",
      line2: "immacolati,",
      line3: "casa accogliente.",
      sub: "Cozy Home è un'impresa di pulizie di Utrecht per cantieri post-ristrutturazione, ristoranti, strutture ricettive, uffici e case private — dove la precisione incontra il calore.",
      cta: "Richiedi preventivo",
      scroll: "Scorri per esplorare",
    },
    marquee: ["Pulizie Premium", "Utrecht", "Post-Ristrutturazione", "Strutture Ricettive", "Case Private", "Ristoranti & Bar", "Uffici"],
    manifesto: {
      title: "Cura, in ogni angolo.",
      items: [
        { n: "01", h: "Trattiamo gli ambienti come case", p: "Ogni spazio che tocchiamo resta calmo, luminoso e arioso. Non puliamo solo le superfici — restituiamo la sensazione di un luogo." },
        { n: "02", h: "Formati, discreti, affidabili", p: "Un team di Utrecht selezionato, con i prodotti giusti per ogni materiale. Assicurati, puntuali e meticolosi fin dalla prima visita." },
        { n: "03", h: "Il dettaglio fa la differenza", p: "Battiscopa, fughe, bordi dei vetri. Le parti che nessuno nota finché non brillano — è lì che va la nostra attenzione." },
      ],
    },
    services: {
      title: "Cosa puliamo",
      sub: "Quattro specializzazioni, un unico standard.",
      list: [
        { t: "Post-ristrutturazione", d: "Rimozione di polvere, residui, schizzi di vernice e pulizia profonda per rendere un nuovo immobile pronto all'uso." },
        { t: "Ristoranti, bar e uffici", d: "Pulizie ricorrenti e affidabili per spazi commerciali ad alto traffico, secondo i tuoi orari." },
        { t: "Strutture ricettive", d: "Pulizie di ricambio per hotel, B&B e soggiorni brevi con una costanza da hotel di livello." },
        { t: "Case private", d: "Pulizie domestiche regolari o una tantum con un tocco caldo, affidabile e attento ai dettagli." },
      ],
    },
    testimonials: {
      title: "Recensioni",
      list: [
        { q: "Dopo la ristrutturazione, Cozy Home ha trasformato un cantiere polveroso in una casa in un solo giorno. Impeccabile.", a: "Marieke V., Utrecht" },
        { q: "Il nostro ristorante non è mai stato così curato. Puntuali, discreti e davvero meticolosi.", a: "Lorenzo B., Titolare ristorante" },
        { q: "Il team di pulizie più affidabile con cui abbiamo lavorato nelle nostre case vacanza.", a: "Sanne D., Responsabile struttura" },
      ],
    },
    footer: { tagline: "Impresa di pulizie", address: "Utrecht, Paesi Bassi", rights: "Tutti i diritti riservati.", contact: "Contatti" },
  },
  es: {
    nav: { services: "Servicios", about: "Método", testimonials: "Opiniones", quote: "Pedir presupuesto", book: "Reservar ahora" },
    hero: {
      eyebrow: "Empresa de limpieza — Utrecht, NL",
      line1: "Espacios",
      line2: "impecables,",
      line3: "hogar acogedor.",
      sub: "Cozy Home es una empresa de limpieza de Utrecht para obras tras reformas, restaurantes, alojamientos, oficinas y casas particulares — donde la precisión se une a la calidez.",
      cta: "Pedir presupuesto",
      scroll: "Desplázate para explorar",
    },
    marquee: ["Limpieza Premium", "Utrecht", "Tras Reforma", "Alojamientos", "Casas Particulares", "Restaurantes y Bares", "Oficinas"],
    manifesto: {
      title: "Cuidado, en cada rincón.",
      items: [
        { n: "01", h: "Tratamos las estancias como hogares", p: "Cada espacio que tocamos queda tranquilo, luminoso y fresco. No solo limpiamos superficies — devolvemos la sensación de un lugar." },
        { n: "02", h: "Formados, discretos, fiables", p: "Un equipo de Utrecht verificado, con los productos adecuados para cada material. Asegurados, puntuales y minuciosos desde la primera visita." },
        { n: "03", h: "El detalle marca la diferencia", p: "Rodapiés, juntas, bordes de cristal. Las partes que nadie nota hasta que brillan — ahí es donde va nuestra atención." },
      ],
    },
    services: {
      title: "Qué limpiamos",
      sub: "Cuatro especialidades, un mismo estándar.",
      list: [
        { t: "Tras reforma", d: "Eliminación de polvo, residuos, salpicaduras de pintura y limpieza a fondo para dejar una obra nueva lista para entrar a vivir." },
        { t: "Restaurantes, bares y oficinas", d: "Limpieza recurrente y fiable para espacios comerciales de alto tránsito, según tu horario." },
        { t: "Alojamientos y hostelería", d: "Limpieza de rotación para hoteles, B&B y estancias cortas con una constancia de nivel hotelero." },
        { t: "Casas particulares", d: "Limpieza del hogar regular o puntual con un toque cálido, fiable y cuidado al detalle." },
      ],
    },
    testimonials: {
      title: "Opiniones",
      list: [
        { q: "Tras nuestra reforma, Cozy Home convirtió una obra polvorienta en un hogar en un solo día. Impecable.", a: "Marieke V., Utrecht" },
        { q: "Nuestro restaurante nunca se vio tan impecable. Puntuales, discretos y realmente minuciosos.", a: "Lorenzo B., Dueño de restaurante" },
        { q: "El equipo de limpieza más fiable con el que hemos trabajado en nuestras casas de huéspedes.", a: "Sanne D., Gerente de alojamiento" },
      ],
    },
    footer: { tagline: "Empresa de limpieza", address: "Utrecht, Países Bajos", rights: "Todos los derechos reservados.", contact: "Contacto" },
  },
};
